import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile } from '@/models';

@Component({
  name: 'CmgCustomerGreeting'
})
export default class CmgCustomerGreeting extends Vue {

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return  profile && !profile.isGuest ? profile : null;
  }

  get customerName(): string {
    if (this.customer !== null && this.customer !== undefined && this.customer.firstName) {
      if(this.customer?.firstName?.length > 12) {
        return this.customer?.firstName.substring(0, 12).toLowerCase() + "...";
      } else {
        return this.customer?.firstName.toLowerCase() ?? "";
      }
    } else {
      return "";
    }
  }
}
